export default {
  REQUIRED: 'Bitte ausfüllen!',
  EMAIL: {
    LENGTH: 'Max. 64 Zeichen erlaubt',
    INVALID: 'E-Mail ungültig',
  },
  PASSWORD: {
    INVALID: 'Mind. 8 Zeichen, mind. ein Großbuchstabe, mind. eine Zahl, mind. ein Sonderzeichen',
    MISMATCH: 'Die Passwörter müssen übereinstimmen',
  },
  PHONE: {
    INVALID: 'Telefonnummer ungültig',
  },
  NUMBER: {
    INVALID: 'Nummer ungültig',
  },
  IBAN: {
    INVALID: 'Ungültige deutsche IBAN (DE + 22 Zeichen: 2 Prüfziffern, 8-stellige BLZ, 10-stellige Kontonummer)',
  },
  LANR: {
    INVALID: 'Ungültige LANR (9-stellige Ziffernfolge)',
  },
  FILE_INPUT: {
    INVALID_TYPE: 'Ungültiges Dateiformat',
    SIZE_EXCEEDED: 'Die Datei darf maximal {maxSize} MB groß sein. Dies ist optional, Sie können dies nach der Registrierung in Ihrem Profil vervollständigen.',
  },
};
